/*
Author: Ayi
*/

import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';
import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import PropTypes from 'prop-types';
const propTypes = {
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  hideLabel: PropTypes.bool,
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  hideSearch: PropTypes.bool,
};
const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  hideLabel: false,
  inputContainerStyle: {},
  value: '',
  hideSearch: false,
};
const limit = 10;
const ParentGroupSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    hasError = false,
    hideLabel = false,
    inputContainerStyle = {},
    value = '',
    hideSearch = false,
  } = props;
  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);
  const marketType = useApi(MsB2b.getMarketType);
  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      const filter = { is_parent_group: true };
      if (val) {
        filter.code = { $regex: val, $options: 'i' };
      }
      if (!val && filter.code) {
        delete filter.code;
      }
      const response = await marketType.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data
          .filter((bt) => bt.is_active)
          .map((item) => {
            return {
              id: item.id,
              code: item.code,
              cerebro_id: item.cerebro_id,
              parent_id: item.parent_id,
              parent_code: item.parent_code,
            };
          });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };
  return (
    <SelectBox
      label="Parent Group"
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore
          ? 'Loading...'
          : 'Select Parent Group'
      }
      trackBy="id"
      labelKey="code"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial}
      hideLabel={hideLabel}
      inputContainerStyle={inputContainerStyle}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={false}
      hideSearch={hideSearch}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        setSkip(0);
        onSearch();
      }}
    />
  );
};
ParentGroupSearch.propTypes = propTypes;
ParentGroupSearch.defaultProps = defaultProps;
export default ParentGroupSearch;
